export default function Footer() {
  return <div className="footer">Sol Olivia © 2026. All rights reserved.</div>;
}